import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Loader } from "lucide-react";
function FavoritesGrid() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="h-[400px] md:h-[500px] w-full rounded-xl bg-muted animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-20">
        <p className="text-muted-foreground mb-4">Unable to load favorites.</p>
        <button onClick={refetch} className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2">
          Try Again
        </button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-20 bg-muted/30 rounded-xl">
        <p className="text-muted-foreground">No popular guides found at the moment.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {posts.map((post, i) => <Link key={post.id} to={post.link || "#"} className="group relative block h-[400px] md:h-[500px] w-full overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300" data-index={i}>
          {/* Background Image */}
          <div className="absolute inset-0">
            {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" /> : <div className="h-full w-full bg-muted flex items-center justify-center">
                <span className="text-muted-foreground">No Image</span>
              </div>}
            {/* Overlay */}
            <div className="absolute inset-0 bg-black/30 transition-colors duration-300 group-hover:bg-black/40" />
          </div>

          {/* Badge */}
          <div className="absolute top-6 right-6 z-10">
            <Badge className="bg-white/90 text-foreground hover:bg-white backdrop-blur-sm px-3 py-1 text-xs uppercase tracking-wider font-medium border-none shadow-sm">
              Popular
            </Badge>
          </div>

          {/* Content */}
          <div className="absolute bottom-0 left-0 w-full p-8 md:p-10 z-10 flex flex-col gap-3">
            {/* Category */}
            {post.categories && post.categories.length > 0 && <span className="text-xs font-medium tracking-widest text-white/80 uppercase mb-1">
                {post.categories[0].name}
              </span>}
            
            <h3 className="font-serif text-2xl md:text-4xl text-white leading-tight group-hover:underline decoration-1 underline-offset-4 decoration-white/60">
              {post.title}
            </h3>
            
            <div className="flex items-center gap-2 text-white/90 text-sm font-medium mt-2 opacity-0 transform translate-y-4 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0">
              Read Guide <ArrowRight className="h-4 w-4" />
            </div>
          </div>
        </Link>)}
    </div>;
}
export default function ReaderFavorites() {
  const wp_query_params = {
    per_page: 4,
    orderby: "date",
    order: "desc",
    ignore_sticky: true
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="reader-favorites" className="bg-background py-20 md:py-28">
      <div className="container mx-auto px-4">
        <div className="mb-12 md:mb-16 text-center max-w-2xl mx-auto">
          <h2 className="font-serif text-4xl md:text-5xl text-foreground mb-4">
            Reader Favorites
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-light">
            Our most loved guides on organizing, decluttering, and creating a peaceful home.
          </p>
        </div>

        <PostsProvider wp_query={{
        per_page: 4,
        orderby: "date",
        order: "desc",
        ignore_sticky: true
      }}>
          <FavoritesGrid />
        </PostsProvider>
      </div>
    </section>;
}